export default __webpack_public_path__ + "static/media/p8.f09abeba.jpg";